'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _jsxFileName = 'src/new-business/stage4/components/quote.js';
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _constants = require('@marmalade/contact/lib/constants');
var _updateFields = require('@marmalade/form/lib/actions/update-fields');
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _grid = require('@marmalade/grid');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _panel = require('@marmalade/panel');
var _progressBar = require('@marmalade/progress-bar');
var _propTypes = require('@marmalade/prop-types');
var _glamorous = require('glamorous');
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _actions = require('../../../quote/actions');
var _selectors = require('../../../quote/selectors');
var _constants2 = require('../../constants');
var _quoteOptionsToProps = require('../../selectors/quote-options-to-props');
var _quoteOptionsToProps2 = _interopRequireDefault(_quoteOptionsToProps);
var _form = require('./form');
var _form2 = _interopRequireDefault(_form);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants2.stages[3].formId;
Wrapper.propTypes = {
  children: _propTypes2.node.isRequired,
  container: _propTypes2.bool.isRequired
};
function Wrapper(_ref) {
  var children = _ref.children,
    container = _ref.container;
  var Component = container ? _grid.Container : _react.Fragment;
  return _react2.default.createElement(Component, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }, _react2.default.createElement(_progressBar.WithStages, {
    newBusinessStages: _constants2.stages,
    active: 4,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  }), children);
}
var Quote = function (_Component) {
  _inherits(Quote, _Component);
  function Quote(props) {
    _classCallCheck(this, Quote);
    var _this = _possibleConstructorReturn(this, (Quote.__proto__ || Object.getPrototypeOf(Quote)).call(this, props));
    _this.tryAgain = function () {
      _this.props.resetFields(formId, ['coverStartDate']);
      window.location.reload();
    };
    if (props.quoted) {
      props.clearQuotes();
    }
    return _this;
  }
  _createClass(Quote, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setValue(formId, 'coverStartDate', this.props.initCoverStartDate);
      this.props.setValue(formId, 'cover', this.props.stage3Values.cover || '30');
      this.props.fetchQuotes(this.props.theme);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.quoteError) {
        this.props.history.push(this.props.linkPrefix + '/noquote');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Wrapper, {
        container: this.props.container,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        },
        __self: this
      }, this.props.requestError ? _react2.default.createElement(_panel.Panel, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        },
        __self: this
      }, 'Sorry, something went wrong. Please call us at ', _react2.default.createElement('a', {
        href: 'tel:' + _constants.phone.ldi,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        },
        __self: this
      }, _constants.phone.ldi), '.'), _react2.default.createElement(_button2.default, {
        prominence: 'primary',
        text: 'Try again',
        onClick: this.tryAgain,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        },
        __self: this
      })) : _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        },
        __self: this
      }, this.props.quoted ? _react2.default.createElement(_form2.default, {
        linkPrefix: this.props.linkPrefix,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        },
        __self: this
      }) : _react2.default.createElement(_loading2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        },
        __self: this
      })));
    }
  }]);
  return Quote;
}(_react.Component);
Quote.propTypes = {
  linkPrefix: _propTypes2.string.isRequired,
  container: _propTypes2.bool.isRequired,
  history: _propTypes.history.isRequired,
  // STP - options for quote
  initCoverStartDate: _propTypes2.array.isRequired,
  // STP - quote info
  quoteError: _propTypes2.bool.isRequired,
  requestError: _propTypes2.bool.isRequired,
  quoted: _propTypes2.bool.isRequired,
  // DTP
  fetchQuotes: _propTypes2.func.isRequired,
  clearQuotes: _propTypes2.func.isRequired,
  setValue: _propTypes2.func.isRequired,
  resetFields: _propTypes2.func.isRequired,
  // Additional options for TP Email (#2019611)
  stage3Values: _propTypes2.object.isRequired,
  coverStartDate: _propTypes2.array,
  theme: _propTypes2.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return Object.assign({
    quoteError: (0, _selectors.getQuoteInfo)(state).quoteError,
    requestError: (0, _selectors.getQuoteInfo)(state).requestError,
    quoted: (0, _selectors.hasQuoted)(state)
  }, (0, _quoteOptionsToProps2.default)(state), {
    stage3Values: (0, _formInfo.getValues)(state, _constants2.stages[3].formId)
  });
}, {
  fetchQuotes: _actions.fetchFullQuote,
  clearQuotes: _actions.clearQuotes,
  setValue: _updateFields.setValue,
  resetFields: _updateFields.resetFields
})((0, _glamorous.withTheme)(Quote));